/**
 * wraps {@link setTimeout} in a new Promise in order to wait for a certain
 * amount of time
 */
export async function wait(ms: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), ms)
  })
}
